import axios from "axios";
import { removeUndefinedValues } from "../utils";

const toCsv = (vals) => {
  if (!vals) return undefined;
  const arr = Array.isArray(vals) ? vals : [vals];
  const cleaned = arr
    .map((x) => (typeof x === "string" ? x : x?.value ?? x?.label ?? ""))
    .map((s) => String(s).trim())
    .filter(Boolean);
  return cleaned.length ? cleaned.join(",") : undefined;
};

class recipes {
  static getRecepieSuggestion() {
    const id = localStorage.getItem("interested") || parseInt(Math.random() * 100);
    const payload = {
      apiKey: process.env.REACT_APP_API_KEY,
      number: 4,
    };
    return axios.get(
      `https://api.spoonacular.com/recipes/${id}/similar?${new URLSearchParams(payload)}`
    );
  }

  static getRecepies(options = {}) {
    const { number = 20, offset = 0, cuisine, diet, intolerances, query } = options;

    const payload = {
      apiKey: process.env.REACT_APP_API_KEY,
      number,
      offset,
      cuisine,
      diet,
      intolerances: toCsv(intolerances),
      query,
      sort: "random",        // 👈 ensures fresh random recipes every time
      t: Date.now(),         // 👈 cache buster so results change on refresh
    };

    return axios.get(
      `https://api.spoonacular.com/recipes/complexSearch?${new URLSearchParams(
        removeUndefinedValues(payload)
      )}`
    );
  }

  static getRecepieDetail(id) {
    const payload = { apiKey: process.env.REACT_APP_API_KEY };
    return axios.get(
      `https://api.spoonacular.com/recipes/${id}/information?${new URLSearchParams(payload)}`
    );
  }
}

export default recipes;
